import * as Joi from 'joi-browser';

const schema = Joi.object().keys({
  comment: Joi.string()
    .optional()
    .allow(''),
});

export default schema;
